import React from 'react';
import cx from 'clsx';
import { ComponentType } from '../../util/ComponentType';
import fixRichText from '../../util/fixRichText';
import classes from './Text.module.scss';

export interface TextProps {
  className?: string;
  children?: React.ReactNode | string;
  style?: Record<string, any>;
  bold?: boolean;
  error?: boolean
}

export default function Text<T extends React.ElementType = 'p'>({
  className,
  //@ts-ignore
  component: Element = 'p',
  children = null,
  style,
  bold,
  error,
  ...others
}: TextProps & ComponentType<T>) {
  const isTitle = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(Element as string);
  const isHtml = typeof children === 'string' && /<\/?[a-z][\s\S]*>/i.test(children);
  const linkProps = Element === 'a' ? { rel: 'noopener noreferrer' } : {};

  if (isHtml) {
    return (
      <div
        className={cx(classes.text, {
          [classes.bold]: bold,
          [classes.error]: error,
          [classes.withChildren]: isHtml,
        }, className)}
        style={style}
        {...others}
        dangerouslySetInnerHTML={{ __html: fixRichText(children) }}
      />
    );
  }

  return (
    //@ts-ignore
    <Element
      className={cx(classes.text, {
        [classes.bold]: bold,
        [classes[Element as string]]: isTitle,
        [classes.error]: error,
      }, className)}
      style={style}
      {...linkProps}
      {...others}
    >
      {typeof children === 'string' ? fixRichText(children) : children}
    </Element>
  );
}

Text.displayName = '@ioa/lablocator/Text';
